import { createFileRoute, useNavigate } from "@tanstack/react-router"

import { FeedbackList } from "@/features/feedback/feedback-list"

export const Route = createFileRoute("/feedback/")({ component: FeedbackScreen })

/**
 * The review list. Thin on purpose: a TanStack route file may export nothing
 * but its `Route`, so everything worth testing lives in the feature and the
 * route owns only the navigation, which is the one thing the feature cannot
 * do without a router in the test.
 *
 * No role guard here, exactly as `/imports` has none: the screen stays
 * reachable by URL, the navigation entry is Administrator-only, and the
 * endpoint refuses anyone else, which the list surfaces as its error state.
 * A guard in the client would be a second, weaker copy of a rule the server
 * already enforces.
 */
function FeedbackScreen() {
  const navigate = useNavigate()
  return (
    <FeedbackList
      onOpen={(id) =>
        void navigate({ to: "/feedback/$entryId", params: { entryId: String(id) } })
      }
    />
  )
}
